import {styled} from '@mui/material/styles'
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress'

// The survey's progress bar: a slim bar with a teal fill. Shared by the live
// respondent runner and the no-write preview so both read identically and
// cannot drift apart.
const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
  height: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: '#007A7A',
    ...theme.applyStyles('dark', {
      backgroundColor: '#007A7A',
    }),
  },
}))

export default BorderLinearProgress
